import { render, staticRenderFns } from "./unitCard.vue?vue&type=template&id=0366cabc&"
import script from "./unitCard.vue?vue&type=script&lang=js&"
export * from "./unitCard.vue?vue&type=script&lang=js&"
import style0 from "./unitCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports